<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>配送情報</h2>
      </v-col>
    </v-row>
    <v-row v-if="item.is_deleted">
      <v-col>
        <span class="subtitle-1 red--text">※このデータは削除済です。</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>配送情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="顧客コードまたは送付先コード"
          readonly
          v-model="item.subscription.client.cd"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="発送方法"
          readonly
          v-model="item.shippingmethod.name"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          item-text="label"
          item-value="id"
          v-model="item.subscription.client.industrycode"
          readonly
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="会社名または個人名"
          v-model="item.name1"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          v-model="item.name2"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          v-model="item.name3"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          v-model="item.name4"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="敬称"
          v-model="item.name_title"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="郵便番号"
          v-model="item.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="都道府県"
          v-model="item.prefecture.name"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所1"
          v-model="item.address1"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          v-model="item.address2"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          v-model="item.tel"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          v-model="item.fax"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>配送内容</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品カテゴリ"
          v-model="item.deliveryitemdetail.deliveryitem.deliveryitemcategory.name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品"
          v-model="item.deliveryitemdetail.deliveryitem.name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品明細"
          v-model="item.deliveryitemdetail.name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="個数"
          v-model="item.amount"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="発送予定日"
          readonly
          v-model="item.delivery_date"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="4"
      ><v-btn class="red white--text" @click="download">配送データダウンロード</v-btn></v-col>
      <v-col
        cols="12"
        md="2"
        sm="3"
      >
        <v-text-field
          label="発行回数"
          v-model="item.publish_count"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="4"
      >
        <v-text-field
          label="最終発行日"
          readonly
          v-model="item.last_publish_date"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      item: {
        prefecture: {},
        client: {'cd': null, 'industrycode': null},
        deliveryitemdetail: {
          deliveryitem: {
            deliveryitemcategory: {},
          }
        },
        shippingmethod: {},
      },
    }
  },
  created() {
    this.getItem();
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ShippingList'}).catch(()=>{});
      }
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippings/${this.$route.params.id}/pdf/`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "shipping.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>